import React, { lazy, ComponentType } from 'react';

/**
 * A wrapper for React.lazy that attempts to reload the page or retry the import
 * if a ChunkLoadError occurs (common after new deployments).
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await componentImport();
    } catch (error) {
      console.error('Lazy loading error, checking for updates...', error);
      
      // Check if we've already tried to reload to avoid infinite loops
      const hasReloaded = window.sessionStorage.getItem('app_chunk_retry');
      
      if (!hasReloaded) {
        window.sessionStorage.setItem('app_chunk_retry', 'true');
        window.location.reload();
        // Return a promise that never resolves while the page reloads
        return new Promise(() => {}) as any;
      }

      // If we already reloaded and it still fails, bubble up to ErrorBoundary
      throw error;
    }
  });
}
